// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tour container */
.shepherd-element {
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  font-family: 'Inter', sans-serif;
  padding: 0.75rem;
}

/* Title */
.shepherd-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.25rem;
}

/* Text / description */
.shepherd-text {
  font-size: 0.95rem;
  line-height: 1.4;
  color: #4b5563;
}

/* Buttons */
.shepherd-button {
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.5rem 1.25rem;
  transition: background-color 0.2s;
}

.shepherd-button-primary {
  background: #2563eb;
  color: white;
}

.shepherd-button-primary:hover {
  background: #1e40af;
}

.shepherd-button-secondary {
  background: #f3f4f6;
  color: #111827;
}

.shepherd-button-secondary:hover {
  background: #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tour/shepherd-theme.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Tour container */\n.shepherd-element {\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  font-family: 'Inter', sans-serif;\n  padding: 0.75rem;\n}\n\n/* Title */\n.shepherd-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 0.25rem;\n}\n\n/* Text / description */\n.shepherd-text {\n  font-size: 0.95rem;\n  line-height: 1.4;\n  color: #4b5563;\n}\n\n/* Buttons */\n.shepherd-button {\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 0.5rem 1.25rem;\n  transition: background-color 0.2s;\n}\n\n.shepherd-button-primary {\n  background: #2563eb;\n  color: white;\n}\n\n.shepherd-button-primary:hover {\n  background: #1e40af;\n}\n\n.shepherd-button-secondary {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.shepherd-button-secondary:hover {\n  background: #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
